module.exports = "<!-- <big-title></big-title> -->\r\n<app-breadnav-component></app-breadnav-component>\r\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/sainik-registration/sainik-registration.component.html
// module id = ./src/app/sainik-registration/sainik-registration.component.html
// module chunks = main